import React from 'react'
import InputGroup from "react-bootstrap/InputGroup";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function (props) {
    if (!!props.icon) {
        return (
            <InputGroup.Prepend>
                <InputGroup.Text>
                    <FontAwesomeIcon icon={props.icon}/>
                </InputGroup.Text>
            </InputGroup.Prepend>
        )
    }

    if (!!props.text) {
        return (
            <InputGroup.Prepend>
                <InputGroup.Text>
                    <small>{props.text}</small>
                </InputGroup.Text>
            </InputGroup.Prepend>
        )
    }
}